import { defineStore } from 'pinia'

export const useSearchTimeStore = defineStore('searchTimeStore', {
  state: () => ({
    ONE_DAY: 1000 * 60 * 60 * 24, // 一天的毫秒数

    searchTimes: 0,
    searchDate: new Date(),
    showDialogVisible: false,
    // JCH5-376 H5新增注册场景及会员线索场景
    currentUserOpenShopTimes: 0,
    lastOpenShopTimes: new Date(),
    showOpenShopVisible: false,

    // 合作保障风险名单
    RISK_SEARCH_LIMIT: 3, // 风险名单搜索次数限制

    riskSearchTimes: 0,
    riskSearchDate: new Date(),
    riskShowDialogVisible: false,

    riskClickTimes: 0, // 合作保障风险名单--点击次数
    riskClickCompIds: [] as string[],
    riskClickDate: new Date(),
  }),
  getters: {
    shopOpenTimes: (state) => state.currentUserOpenShopTimes,
    // riskSearchTimes: (state) => state.riskSearchTimes,
  },
  actions: {
    changeDialogVisible(value: boolean) {
      this.showDialogVisible = value
    },
    closeSearchDialog() {
      this.showDialogVisible = false
    },
    openSearchDialog() {
      this.showDialogVisible = true
    },
    addSearchTimes() {
      const currentDate = new Date()
      const timeDiff =
        currentDate.getTime() - new Date(this.searchDate).getTime()
      if (timeDiff > 1000 * 60 * 60 * 24) {
        // 超过24小时，重置搜索次数并更新时间
        this.resetSearchTimes()
      }
      // 增加搜索次数
      this.searchTimes++
    },
    resetSearchTimes() {
      const currentDate = new Date()
      this.searchTimes = 0
      this.searchDate = currentDate
    },
    getSearchTimes() {
      return this.searchTimes
    },

    // 新增未登录用户商铺打开次数限制
    resetOpenTimes() {
      const currentDate = new Date()
      const timeDiff =
        currentDate.getTime() - new Date(this.lastOpenShopTimes).getTime()
      if (timeDiff > this.ONE_DAY) {
        // 超过24小时，重置搜索次数并更新时间
        this.currentUserOpenShopTimes = 0
        this.lastOpenShopTimes = new Date()
      }
    },
    // 增加打开商铺次数
    addOpenShopTimes() {
      const currentDate = new Date()
      const timeDiff =
        currentDate.getTime() - new Date(this.lastOpenShopTimes).getTime()
      // 重置搜索次数并更新时间
      this.resetOpenTimes()
      // 增加搜索次数
      this.currentUserOpenShopTimes++
    },
    openShopDialog(path: string) {
      this.showOpenShopVisible = true
      const systemStore = useMySystemStore()
      const isCn = systemStore.language === 'zh-CN'
      const isApp = systemStore.isAPP
      const CLiCK_SOURCE = isApp
        ? 'PLT.REG.APP.APP_ERA_OPEN_SHOP_COMPANY'
        : 'PLT.REG.H5.H5_ERA_OPEN_SHOP_COMPANY'
      showConfirmDialog({
        title: '',
        message: isCn
          ? '登录解锁新的身份，可查看更多信息'
          : 'Sign in to view more information',
        cancelButtonText: isCn ? '取消' : 'Cancel',
        confirmButtonText: isCn ? '登录' : 'Sign in',
      })
        .then(async () => {
          this.closeShopDialog()
          go2LoginPageWithCrmSource(path, CLiCK_SOURCE)
        })
        .catch(() => {
          this.closeShopDialog()
        })
    },
    closeShopDialog() {
      this.showOpenShopVisible = false
    },

    // 合作保障风险名单
    addRiskSearchTimes() {
      const currentDate = new Date()
      const timeDiff =
        currentDate.getTime() - new Date(this.riskSearchDate).getTime()
      if (timeDiff > 1000 * 60 * 60 * 24) {
        // 超过24小时，重置搜索次数并更新时间
        this.resetRiskSearchTimes()
      }
      this.riskSearchTimes++
    },
    resetRiskSearchTimes() {
      this.riskSearchTimes = 0
      this.riskSearchDate = new Date()
    },

    riskToLogin(registerEntry: string) {
      this.riskShowDialogVisible = true
      const systemStore = useMySystemStore()
      if (!systemStore.userIsLogin) {
        go2LoginPageWithCrmSource(
          useRoute().fullPath,
          // 用户未登录，成功触发3次搜索后，直接跳转登录页面
          // 1、平台 2、注册 3、网站注册 4、新主站H5风险名单搜索3次
          systemStore.isAPP
            ? 'PLT.REG.APP.APP_ERA_RISK_SEARCH_OVER_THREE_LIMIT'
            : 'PLT.REG.H5.H5_ERA_RISK_SEARCH_OVER_THREE_LIMIT',
          registerEntry,
        )
      }
    },

    riskLoadMoreToLogin(registerEntry: string) {
      const systemStore = useMySystemStore()
      if (!systemStore.userIsLogin) {
        go2LoginPageWithCrmSource(
          useRoute().fullPath,
          systemStore.isAPP
            ? 'PLT.REG.APP.APP_ERA_RISK_SEARCH_LOAD_MORE_LIMIT'
            : 'PLT.REG.H5.H5_ERA_RISK_SEARCH_LOAD_MORE_LIMIT',
          registerEntry,
        )
      }
    },

    // 合作保障风险名单--点击次数
    addRiskClickTimes(compId: string) {
      const currentDate = new Date()
      const timeDiff =
        currentDate.getTime() - new Date(this.riskClickDate).getTime()
      if (timeDiff > this.ONE_DAY) {
        this.resetRiskClickTimes()
      }
      if (
        !this.riskClickCompIds.includes(compId) &&
        this.riskClickCompIds.length < 3
      ) {
        this.riskClickCompIds.unshift(compId + '')
        this.riskClickTimes++
      }
    },
    resetRiskClickTimes() {
      this.riskClickTimes = 0
      this.riskClickDate = new Date()
      this.riskClickCompIds = []
    },
    riskClickToLogin(registerEntry: string) {
      const systemStore = useMySystemStore()
      // 用户未登录，风险保障首页/风险名单的suspend客户卡片点击超过3个，直接跳转登录页面
      // 1、平台 2、注册 3、网站注册 4、新主站H5风险禁止名单点击超过3个
      if (!systemStore.userIsLogin) {
        go2LoginPageWithCrmSource(
          useRoute().fullPath,
          systemStore.isAPP
            ? 'PLT.REG.APP.APP_ERA_RISK_CLICK_LIMIT'
            : 'PLT.REG.H5.H5_ERA_RISK_CLICK_LIMIT',
          registerEntry,
        )
      }
    },

    // 超出搜索次数限制跳转登录页面方法
    handleSearchLimitExceedToLogin(
      type: 'risk' | 'risk_load_more' | 'risk_click',
      registerEntry: string,
    ) {
      // 用户未登录，成功触发3次搜索后，直接跳转登录页面
      if (type === 'risk') {
        this.riskToLogin(registerEntry)
      }
      // 用户未登录，翻页
      if (type === 'risk_load_more') {
        this.riskLoadMoreToLogin(registerEntry)
      }
      // 用户未登录，点击第四家suspend
      if (type === 'risk_click') {
        this.riskClickToLogin(registerEntry)
      }
    },
  },
  persist: {
    storage: persistedState.localStorage,
  },
})
